export enum TemporalReference {
  CURRENT = 'current',
  HISTORY = 'history',
}
